<template>
  <section id="dashboard">
    <v-container class="fill-height">
      <!-- Select Filter -->
      <v-row justify="end" align="center">
        <v-col cols="4" md="auto" class="text-right pr-0">
          <small class="font-weight-medium">Colas:</small>
        </v-col>

        <v-col cols="8" md="auto">
          <v-switch
            v-model="QueueSearch"
            inset
            @change="requestDashboard"
          ></v-switch>
        </v-col>

        <v-col cols="4" md="auto" class="text-right">
          <small class="font-weight-medium">Mostrar por:</small>
        </v-col>

        <v-col cols="8" md="auto" lg="2">
          <v-select
            :disabled="!render"
            :items="DateItems"
            v-model="DateSearch"
            filled
            rounded
            single-line
            dense
            class="rounded-small"
            hide-details
            @change="requestDashboard"
          ></v-select>
        </v-col>
      </v-row>

      <!-- Graphs -->

      <!-- Slider minicard for Mobiles -->
      <!-- <v-slide-group class="mt-2" v-if="isMobile && render">
        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>

        <v-slide-item class="mb-7">
          <v-card class="shadow-5 mx-2" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-slide-item>
      </v-slide-group> -->
      <!-- Minicards for Desktops -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card height="150" outlined class="py-3" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="6">
          <v-card height="150" outlined class="py-3" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <!-- <v-col cols="12" md="3">
          <v-card outlined class="py-3" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col> -->

        <!-- <v-col cols="12" md="3">
          <v-card outlined class="py-3" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col> -->
      </v-row>

      <v-row align="stretch">
        <v-col cols="12" md="5" class="d-flex flex-column">
          <v-card class="shadow-5 flex-grow-1" v-if="render">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Por agente
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart5"
                type="donut"
                :options="optionsDonutByAgents"
                :series="serieDonutByAgent"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto flex-grow-1"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="7" class="d-flex flex-column">
          <v-card class="shadow-5 flex-grow-1" v-if="render">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Por agente y tipificación
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart6"
                type="bar"
                :options="optionsBarByAgentAndType"
                :series="serieBarByAgentAndType"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto flex-grow-1"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="5" class="d-flex flex-column">
          <v-card class="shadow-5 flex-grow-1" v-if="render">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Por cola
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart7"
                type="donut"
                :options="optionsDonutByQueues"
                :series="serieDonutByQueue"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto flex-grow-1"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>
        
        <v-col cols="12" md="7" class="d-flex flex-column">
            <v-card class="shadow-5 flex-grow-1" v-if="render">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Por cola y tipo
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart8"
                  type="bar"
                  :options="optionsBarByQueueAndType"
                  :series="serieBarByQueueAndType"
                ></apexchart>
              </v-card-text>
            </v-card>

            <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto flex-grow-1"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  inject: ["theme"],

  data() {
    return {
      render: false,
      userData: {},
      DateItems: ["Hoy", "Ayer", "Mes Actual", "Mes Anterior"],
      QueueSearch: false,
      DateSearch: "Hoy",
      // CONFIGURACIONES PARA GRÁFICAS
      totalCalls: 0,
      totalOutgoingCalls: 0,
      totalIncomingCalls: 0,
      optionsMiniCardsAreaIncoming: {
        chart: {
          sparkline: {
            enabled: true
          }
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins"
          }
        },
        subtitle: {
          text: "Tipificaciones",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins"
          }
        },
        colors: ["#00BCD4"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100]
          }
        },
        xaxis: {
          categories: []
        }
      },
      // optionsMiniCardsAreaOutgoing: {
      //   chart: {
      //     sparkline: {
      //       enabled: true
      //     }
      //   },
      //   title: {
      //     text: 0,
      //     offsetX: 20,
      //     offsetY: 10,
      //     style: {
      //       fontSize: "24px",
      //       fontFamily: "Poppins"
      //     }
      //   },
      //   subtitle: {
      //     text: "Llamadas salientes",
      //     offsetX: 20,
      //     offsetY: 42,
      //     style: {
      //       fontSize: "13px",
      //       fontFamily: "Poppins"
      //     }
      //   },
      //   colors: ["#2196F3"],
      //   fill: {
      //     type: "gradient",
      //     gradient: {
      //       shadeIntensity: 1,
      //       opacityFrom: 0.7,
      //       opacityTo: 0.9,
      //       stops: [0, 100]
      //     }
      //   },
      //   xaxis: {
      //     categories: []
      //   }
      // },

      optionsMiniCardsBarIncoming: {
        chart: {
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            columnWidth: "50%"
          }
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins"
          }
        },
        subtitle: {
          text: "Por tipificar",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins"
          }
        },
        colors: ["#625FA4"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100]
          }
        },
        xaxis: {
          categories: []
        }
      },
      // optionsMiniCardsBarOutgoing: {
      //   chart: {
      //     sparkline: {
      //       enabled: true
      //     }
      //   },
      //   plotOptions: {
      //     bar: {
      //       columnWidth: "50%"
      //     }
      //   },
      //   title: {
      //     text: 0,
      //     offsetX: 20,
      //     offsetY: 10,
      //     style: {
      //       fontSize: "24px",
      //       fontFamily: "Poppins"
      //     }
      //   },
      //   subtitle: {
      //     text: "Extensiones salientes",
      //     offsetX: 20,
      //     offsetY: 42,
      //     style: {
      //       fontSize: "13px",
      //       fontFamily: "Poppins"
      //     }
      //   },
      //   colors: ["#AB47BC"],
      //   fill: {
      //     type: "gradient",
      //     gradient: {
      //       shade: "light",
      //       type: "vertical",
      //       inverseColors: false,
      //       shadeIntensity: 1,
      //       opacityFrom: 0.7,
      //       opacityTo: 1,
      //       stops: [50, 100]
      //     }
      //   },
      //   xaxis: {
      //     categories: []
      //   }
      // },

      optionsDonutByAgents: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              }
            }
          }
        ],
        width: "100%",
        labels: ["Sin datos"],
        legend: {
          position: "bottom",
          show: false
        }
      },

      optionsDonutByQueues: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              }
            }
          }
        ],
        width: "100%",
        labels: ["Sin datos"],
        legend: {
          position: "bottom",
          show: false
        }
      },

      optionsBarIncomingCalls: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '11px', // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        fill: {
          //   colors: ["#6D71F9"],
          colors: ["#008FFB"]
        }
      },
      optionsBarOutgoingCalls: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '11px', // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        fill: {
          colors: ["#00E396"]
          //   colors: ["#FEB019"],
        }
      },
      
      optionsBarByAgentAndType: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '11px', // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
        },
      },

      optionsBarByQueueAndType: {
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '11px', // Tamaño de texto
            },
            rotate: -45, // Para que el texto se vea en ángulo si es muy largo
          },
        },
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        grid: {
          padding: {
            bottom: 60, // Ajusta el espacio inferior
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
        },
      },

      // DATOS PARA GRÁFICAS
      serieDonutByAgent: [1],
      serieDonutByQueue: [1],
      serieBarByAgentAndType: [],
      serieBarByQueueAndType: [],
      



      seriesMiniCardIncomingArea: [
        {
          name: "Llamadas entrantes.",
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      seriesMiniCardOutgoingArea: [
        {
          name: "Llamadas salientes.",
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],

      seriesMiniCardIncomingBar: [
        {
          name: "Llamadas entrantes por extensión",
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      seriesMiniCardOutgoingBar: [
        {
          name: "Llamadas salientes por extensión",
          data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    };
  },

  computed: {
    // DashboardDayValues() {
    //     return this.$store.getters["dashboard/GET_DASHBOARD_DAY"];
    // },

    // DashboardMonthValues() {
    //     return this.$store.getters["dashboard/GET_DASHBOARD_MONTH"];
    // },

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    welcomeCardHeight() {
      if (this.$vuetify.breakpoint.mobile) {
        return "200";
      } else {
        return "150";
      }
    }
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    }
  },

  created() {
    this.requestDashboard();
  },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
  },

  updated() {
    this.changeThemeChart();
  },

  methods: {
    requestDashboard() {
      let value = this.DateSearch;

      this.render = false;
      this.clearAllGraphics();

      switch (value) {
        case "Hoy":
          this.getDashboardDayValues();
          break;
        case "Ayer":
          this.getDashboardYesterdayValues();
          break;

        case "Mes Actual":
          this.getDashboardMonthValues();
          break;
        case "Mes Anterior":
          this.getDashboardMonthYesterdayValues();
          break;

        default:
          this.getDashboardDayValues();
          break;
      }
    },

    async getDashboardDayValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_TIPING_DAY_VALUES",
          {
            yesterday: false,
          }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getDashboardYesterdayValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_TIPING_DAY_VALUES",
          {
            yesterday: true,
            // is_queue: this.QueueSearch
          }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    async getDashboardMonthValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_TIPING_MONTH_VALUES",
          {
            yesterday: false,
          }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
    async getDashboardMonthYesterdayValues() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando"
      });
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_TIPING_MONTH_VALUES",
          {
            yesterday: true,
          }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    graphics(response) {
      // Gráfica de Mini Cards Entrantes //
      // Área
      this.optionsMiniCardsAreaIncoming.title.text = response.typing;

      // Barras
      this.optionsMiniCardsBarIncoming.title.text =
        response.toTypify;

      // Gráfica de dona por Agente
      if(response.typingByAgent.data.length){
        //Retorna todo los valores
        this.serieDonutByAgent = response.typingByAgent.data.map(function(
          value
        ) {
          return value.total;
        });

        //Retorna todo los nombres de los agentes
        this.optionsDonutByAgents.labels = response.typingByAgent.data.map(function(
          value
        ) {
          return value.user_name  + " (" + value.user_ext + ")";
        });
      }
      /////////////////////////////


      // Gráfica de dona por Cola
      if(response.typingByQueue.data.length){
        //Retorna todo los valores
        this.serieDonutByQueue = response.typingByQueue.data.map(function(
          value
        ) {
          return value.total;
        });
        
        //Retorna todo los nombres de los agentes
        this.optionsDonutByQueues.labels = response.typingByQueue.data.map(function(
          value
        ) {
          return value.queue_name + " (" + value.queue_number + ")";
        });
      }
      /////////////////////////////
      
      // Gráfica de dona por Agente y tipo
      let typificationData = {};

      // Recorremos la data para obtener todos los "typification_names" únicos
      let allTypifications = new Set();
      response.typingByAgentAndType.data.forEach(item => {
        item.typification_names.forEach(name => {
          allTypifications.add(name);
        });
      });

      // Convertimos el Set en un Array para poder iterar sobre él
      allTypifications = Array.from(allTypifications);

      // Inicializamos typificationData con arrays vacíos para cada "typification_name"
      allTypifications.forEach(name => {
        typificationData[name] = [];
      });

      // Recorremos los datos para agregar los valores correspondientes a cada "typification_name"
      response.typingByAgentAndType.data.forEach(item => {
        allTypifications.forEach(name => {
          const index = item.typification_names.indexOf(name);

          if (index !== -1) {
            // Si el "typification_name" existe, agregamos el valor correspondiente de "totals"
            typificationData[name].push(item.totals[index]);
          } else {
            // Si no existe, agregamos un 0 para mantener el orden de los usuarios
            typificationData[name].push(0);
          }
        });
      });

      // Establecemos las categorías del gráfico, que son los "user_name" de los usuarios
      this.optionsBarByAgentAndType.xaxis.categories = response.typingByAgentAndType.data.map(item => item.user_name);

      // Generamos las series para el gráfico
      this.serieBarByAgentAndType = allTypifications.map(name => ({
        name: name,
        data: typificationData[name]
      }));

      // console.log("Datos transformados para las series:", this.serieBarByAgentAndType);

      /////////////////////////////

      // Gráfica de barras por Cola y tipo
      let typificationQueueData = {};

      response.typingByQueueAndType.data.forEach(item => {
      // Iteramos sobre los nombres de las tipificaciones
      item.typification_names.forEach((name, index) => {
        // Verificamos que el índice no esté fuera de los límites de 'totals'
        if (index < item.totals.length) {
          // Si no existe la serie para el nombre de tipificación, la inicializamos
          if (!typificationQueueData[name]) {
            typificationQueueData[name] = [];
          }
          // Agregamos el valor correspondiente al nombre de la tipificación en la posición correcta
          typificationQueueData[name].push(item.totals[index]);
        }
      });
    });

      // Rellenar las series con ceros si faltan valores
      const allQueueTypifications = Object.keys(typificationQueueData);
      const maxQueue = response.length; // Número total de usuarios

      allQueueTypifications.forEach(name => {
        while (typificationQueueData[name].length < maxQueue) {
          typificationQueueData[name].push(0); // Llenamos con ceros si faltan valores para un usuario
        }
      });

      // Generamos las series para el gráfico
      this.serieBarByQueueAndType = allQueueTypifications.map(name => ({
        name: name,
        data: typificationQueueData[name]
      }));

      // Establecer las categorías del gráfico
      this.optionsBarByQueueAndType.xaxis.categories = response.typingByQueueAndType.data.map(item => item.queue_name);
      
    //   /////////////////////////////
    },

    clearAllGraphics() {
      this.optionsDonutByAgent = [];
      this.serieBarByAgentAndType = [
        {
          name: "Agentes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
      ];

      this.optionsBarByAgentAndType.xaxis.categories = [];
    },


    /**
     * Cambia el tema de todos los gráficos a oscuro o claro según el estado de `isDark`.
     * Recorre los gráficos referenciados en `$refs` y aplica el nuevo tema.
     *
     * @returns {void}
     */
    changeThemeChart() {
      const mode = this.isDark ? "dark" : "light";

      Object.keys(this.$refs)
        .filter(ref => ref.startsWith("chart")) // Filtra solo los refs que sean gráficos
        .forEach(ref => {
          if (this.$refs[ref]?.updateOptions) {
            this.$refs[ref].updateOptions({ theme: { mode } }, true);
          }
        });
    }
  }
};
</script>
